import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import { GeneralButton } from 'sharedComponents/GeneralButton';
import { echartLegendNames, echartViews } from './constants';
import { getSignalName } from '../helpers';
import { apiCallStatus, assetType } from 'helpers/constants';
import './style.scss';

const EchartLeftHeaderOptions = (props) => {
    const {
        selectedEchartView,
        setSelectedEchartView,
        selectedEchartLegend,
        setSelectedEchartLegend,
        sensorType,
        setChartLoader
    } = props;

    const isMSRasset = sensorType === assetType.MACHSENSOR;
    const legendNames = isMSRasset ? echartLegendNames.msrAsset : echartLegendNames.sensorAsset;

    const handleLegendClick = useCallback((legendName) => {
        setChartLoader(apiCallStatus.LOADING);
        setTimeout(() => {
            setSelectedEchartLegend(legendName);
        }, 500);
    }, [setChartLoader, setSelectedEchartLegend]);

    const handleViewClick = useCallback((view) => {
        setChartLoader(apiCallStatus.LOADING);
        setTimeout(() => {
            setSelectedEchartView(view);
        }, 300);
    }, [setChartLoader, setSelectedEchartView]);

    return (
        <div className='echart-options'>
            <div className='echart-direction'>
                <span className='title'>{translate('ABB.Powertrain.Frontend.fftEchartDirection')}:</span>
                <div className='signals'>
                    {legendNames.map((legendName, index) =>
                        <GeneralButton
                            key={index}
                            id={index}
                            className={selectedEchartLegend === legendName ? ' selected' : ''}
                            type='normal'
                            text={getSignalName(legendName)}
                            onClick={() => handleLegendClick(legendName)}
                        />
                    )}
                </div>
            </div>
            <div className='divider' />
            <div className='echart-view'>
                <span className='title'>{translate('ABB.Powertrain.Frontend.fftEchartViewBy')}:</span>
                <div className='view-buttons'>
                    <GeneralButton
                        className={selectedEchartView === echartViews.FREQUENCY ? ' selected' : ''}
                        type='normal'
                        text={translate('ABB.Powertrain.Frontend.fftEchartFrequency')}
                        onClick={() => handleViewClick(echartViews.FREQUENCY)}
                    />
                    <GeneralButton
                        className={selectedEchartView === echartViews.ORDER_OF_SPEED ? ' selected' : ''}
                        type='normal'
                        text={translate('ABB.Powertrain.Frontend.fftEchartOrderOfSpeed')}
                        onClick={() => handleViewClick(echartViews.ORDER_OF_SPEED)}
                    />
                </div>
            </div>
        </div>
    );
};

EchartLeftHeaderOptions.propTypes = {
    selectedEchartView: PropTypes.string.isRequired,
    setSelectedEchartView: PropTypes.func.isRequired,
    selectedEchartLegend: PropTypes.string.isRequired,
    setSelectedEchartLegend: PropTypes.func.isRequired,
    sensorType: PropTypes.string,
};

EchartLeftHeaderOptions.defaultProps = {
    legendNames: [],
    sensorTypeID: null
};

export default EchartLeftHeaderOptions;
